import { isNil } from 'lodash';
import { AssignmentEntry } from '../entries';
import { AssignmentMeta } from './AssignmentMeta';

export interface AssignmentMetaWithEntry {
  meta: AssignmentMeta;
  entry: AssignmentEntry;
}

export namespace AssignmentMetaWithEntry {
  export function from(
    meta: AssignmentMeta | undefined,
    entry: AssignmentEntry | undefined
  ): AssignmentMetaWithEntry | undefined {
    if (isNil(meta) || isNil(entry)) {
      return undefined;
    }
    return { meta, entry };
  }
}
